/**
 * 分享
 */
import envi from "../../envi";
import { isApplet } from "./env";
import oldShare from "../public/share";
import { getUrlArg } from "@utils/urlUtil";
import { isAppletEnvi } from "@utils/plat";

// 微信H5参数
let wxParams = null;

/**
 * 小程分享
 */
function miniShareConfig(shareConfig) {
    const { path, title, imageUrl } = shareConfig;
    // 判断是否为小程序
    const isMiniApp = !!path.match(/^\//);
    wx.miniProgram.postMessage({
        data: {
            shareInfo: {
                isMiniApp,
                currentPath: location.host + location.pathname, //当前页面路径，不需要参数
                title,
                path, //默认当前页面路径
                imageUrl,
                url: path //风物严选分享的url
            }
        }
    });
}

// 微信H5设置
export async function setWxConfig(cb) {
    const href = window.location.href;
    const indexOf = href.indexOf("#");
    const url = href.slice(0, indexOf);
    if (!wxParams) {
        let res = await new Promise((resolve, reject) => {
            $.ajax({
                url: "https://wx.17u.cn/pub/wxjsapi/getwxapijsonpconfig",
                // url: "//www.ly.com/huochepiao/resource/WXJsApi/GetWXApiConfig",
                type: "get",
                // dataType: "jsonp",
                cache: false,
                data: {
                    url: indexOf > -1 ? url : window.location.href
                },
                success: function (data) {
                    console.log(url);
                    console.log(window.location.href);
                    console.log("请求成功:::", data);
                    if (data.RspCode === 0) {
                        resolve(data.Data);
                    } else {
                        console.log("获取微信配置失败", data.MessageCode);
                        resolve("");
                    }
                },
                error: function (err) {
                    console.log("获取微信配置失败", err);
                    resolve("");
                }
            });
        });
        wxParams = res || {};
    }
    const wxConf = {
        debug: false,
        appId: wxParams.AppId,
        timestamp: wxParams.TimeStamp,
        nonceStr: wxParams.NonceStr,
        signature: wxParams.Signature,
        jsApiList: [
            "updateAppMessageShareData",
            "updateTimelineShareData",
            "onMenuShareTimeline",
            "onMenuShareAppMessage",
            "onMenuShareQQ",
            "onMenuShareWeibo",
            "onMenuShareQZone",
            "startRecord",
            "stopRecord",
            "onVoiceRecordEnd",
            "playVoice",
            "pauseVoice",
            "stopVoice",
            "onVoicePlayEnd",
            "uploadVoice",
            "chooseImage",
            "downloadVoice",
            "chooseImage",
            "previewImage",
            "uploadImage",
            "downloadImage",
            "getLocalImgData",
            "translateVoice",
            "getNetworkType",
            "openLocation",
            "getLocation",
            "hideOptionMenu",
            "showOptionMenu",
            "hideMenuItems",
            "showMenuItems",
            "hideAllNonBaseMenuItem",
            "showAllNonBaseMenuItem",
            "closeWindow",
            "scanQRCode",
            "chooseWXPay",
            "openProductSpecificView",
            "addCard",
            "chooseCard",
            "openCard"
        ],
        openTagList: ["wx-open-launch-app", "wx-open-launch-weapp"]
    };
    wx.config(wxConf);
    wx.ready(function () {
        console.log("wxready");
        cb && cb();
    });
    wx.error(function (res) {
        console.log("wxerror", res);
    });
}

/**
 * 老项目微信分享
 * @param {Record<string, any} shareConfig 分享配置
 */
export function initShare(shareConfig) {
    const { path, title, imageUrl, desc = "" } = shareConfig;
    if (isApplet) miniShareConfig(shareConfig);
    else wxShareConfig();
    return Promise.resolve();
    /**
     * 非小程序分享
     */
    function wxShareConfig() {
        // 暂时废弃此分享 未经验证
        let sharePara = {
            initSuccess: function () {
                if (envi.isInWeixin) {
                    wx.hideAllNonBaseMenuItem();
                    wx.showMenuItems({
                        menuList: ["menuItem:share:appMessage", "menuItem:share:timeline"]
                    });
                }
            }, // 初始化成功回调
            initFailed: function () {} //function(err) // 初始化失败回调
        };
        sharePara = $.extend(sharePara, {
            shareSuccess: function (channel) {
                // 分享成功后回调
                // wxcomwritecallbacklog()
                // onShareSuccess()
            },
            shareFailed: function (channel, err) {
                // 分享失败/取消后回调，取消回调 err = null
            },
            shareChannels: oldShare.getShareChannelsData({
                // 分享到外部渠道，key 取值范围 share.shareChannels
                title: title, // 分享标题
                link: path, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: imageUrl, // 分享图标
                desc,
                _isBack: true, // 是否返回，目前主要用于手Q
                _isLock: false // 是否开启?(锁定)，目前主要用于有票儿app
            })
        });
        oldShare.init(sharePara);
    }
}

// 新项目微信分享
export const share = shareConfig => {
    isAppletEnvi(isMini => {
        if (isMini) miniShareConfig(shareConfig);
        else
            setWxConfig(() => {
                const { path, title, imageUrl, desc = "", success, momentSuccess } = shareConfig;
                // wx.showMenuItems({
                //     menuList: ["menuItem:share:appMessage", "menuItem:share:timeline"]
                // });
                let url = location.href;
                // history.replaceState({}, "", path); // 解决微信自定义链接分享失败的问题 等波微信bug修复 202101206
                // 分享好友
                wx.updateAppMessageShareData({
                    title,
                    link: path,
                    imgUrl: imageUrl,
                    desc,
                    success: function () {
                        // history.replaceState({}, "", url); // 解决微信自定义链接分享失败的问题 等波微信bug修复
                        success && success();
                    },
                    cancel: function () {
                        // history.replaceState({}, "", url); // 解决微信自定义链接分享失败的问题 等波微信bug修复
                    }
                });
                // 朋友圈
                wx.updateTimelineShareData({
                    title,
                    link: path,
                    imgUrl: imageUrl,
                    success: function () {
                        momentSuccess && momentSuccess();
                    }
                });
            });
    });

    return Promise.resolve();
};

// 禁止分享
export const disableShare = menuList => {
    isAppletEnvi(isMini => {
        if (isMini) {
            miniDisableShare();
        } else {
            setWxConfig(() => {
                h5DisableShare(menuList);
            });
        }
    });
};

// H5禁止分享
export const h5DisableShare = menuList => {
    if (menuList) {
        wx.hideMenuItems({
            menuList
        });
        return;
    }
    wx.hideAllNonBaseMenuItem();
    wx.hideOptionMenu();
};

// 小程序禁止分享
export const miniDisableShare = () => {
    getUrlArg("disableShare") && sessionStorage.setItem("disableShare", getUrlArg("disableShare"));
    if (!!sessionStorage.getItem("disableShare")) return;
    let pagePath = "/page/home/webview/webview",
        appletArgs = "&hideShare=1",
        search = location.search,
        hash = location.hash;
    search += (search ? "&" : "?") + "disableShare=1";
    let pageUrl = pagePath + "?src=" + encodeURIComponent(location.protocol + "//" + location.host + location.pathname + search + hash) + appletArgs;
    if (document.referrer) {
        setTimeout(() => {
            history.back();
        }, 50);
        wx.miniProgram.navigateTo({
            url: pageUrl
        });
    } else {
        wx.miniProgram.redirectTo({
            url: pageUrl
        });
    }
};
